var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5H0.5V6H3.5V5ZM4.585 3.38L3.525 2.32L2.82 3.025L3.88 4.085L4.585 3.38ZM6.5 0H5.5V3H6.5V0ZM9.18 3.025L8.475 2.32L7.415 3.38L8.12 4.085L9.18 3.025ZM8.5 5V6H11.5V5H8.5ZM6 4C5.17 4 4.5 4.67 4.5 5.5C4.5 6.33 5.17 7 6 7C6.83 7 7.5 6.33 7.5 5.5C7.5 4.67 6.83 4 6 4ZM7.415 7.62L8.475 8.68L9.18 7.975L8.12 6.915L7.415 7.62V7.62ZM2.82 7.975L3.525 8.68L4.585 7.62L3.88 6.915L2.82 7.975V7.975ZM5.5 11H6.5V8H5.5V11Z",
    fill: "#CC9E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewItem);
export default __webpack_public_path__ + "static/media/new-item.ff1a1c0fade5d9d17b992fe763fa8036.svg";
export { ForwardRef as ReactComponent };